
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wazne-terminy",
      function () {
        return require("private-next-pages/wazne-terminy/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wazne-terminy"])
      });
    }
  